import * as React from 'react';
import { IMarkedListTextBlockSchema } from '../../repositories/countryside-search/entities/marked_list_text_block/MarkedListTextBlockSchema';
import { SeoMarkedListItem } from './components/SeoMarkedListItem';
import * as styles from './SeoMarkedList.css';

export interface ISeoMarkedListProps {
  items: IMarkedListTextBlockSchema[];
}

export const SeoMarkedList: React.FC<ISeoMarkedListProps> = ({ items }) => (
  <div className={styles['container']}>
    {items.map((item, index) => {
      const id = `SeoMarkedListItem_${index}`;

      return <SeoMarkedListItem key={id} id={id} {...item} />;
    })}
  </div>
);
